export default __webpack_public_path__ + "img/85272bedb0c99592ba51889f3a19066d.svg";